var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"spin"}},[(_vm.isShow)?_c('a-spin',{attrs:{"tip":("正在" + _vm.msg + "，请稍后"),"indicator":_vm.indicator}}):_vm._e(),_c('a',{staticStyle:{"display":"none"},attrs:{"href":_vm.href,"id":"export_a"}},[_vm._v("下载")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }